import { Form, Select, Space } from 'antd';
import * as React from 'react';
import { memo, useEffect, useRef, useState } from 'react';
import { ANIMATION_DURATION, langLabels, languages } from '../../admin-knowledge-base.constants';
import { Category, FormProps } from '../../admin-knowledge-base.type';
import { animateForm } from '../../admin-knowledge-base.utils';
import FormButtons from './form-buttons';
import TitleField from './title-field';
import Button from '/react4xp/mixins/ui/button/button';
import { Languages } from '/react4xp/parts/knowledge-base-common/knowledge-base-common.type';

export const CategoryForm = memo(({ onSubmit, close, form, sections }: FormProps<Category>) => {
    const [activeLanguage, setActiveLanguage] = useState<Languages>(languages[0]);
    const localizedFieldsRef = useRef<HTMLDivElement>(null);

    const handleLanguageChange = (language: Languages) => {
        setActiveLanguage(language);
        animateForm(localizedFieldsRef.current);
    };

    useEffect(() => {
        setTimeout(() => {
            form.setFieldValue(['draft', 'title'], form.getFieldValue([activeLanguage, 'title']));
        }, ANIMATION_DURATION / 3);
    }, [activeLanguage]);

    return (
        <Form
            form={form}
            onFinish={onSubmit}
            validateTrigger={['onBlur']}
        >
            <Form.Item
                hidden
                name="id"
            />
            <Form.Item
                name="parent"
                label="Раздел"
            >
                <Select
                    options={sections.map((section) => ({
                        value: section.path,
                        label: section.ru.title,
                    }))}
                />
            </Form.Item>
            <Space.Compact>
                {languages.map((language) => (
                    <Button
                        key={language}
                        onClick={() => handleLanguageChange(language)}
                        color={language === activeLanguage ? 'gold' : ''}
                    >
                        {langLabels[language]}
                    </Button>
                ))}
            </Space.Compact>
            <div ref={localizedFieldsRef}>
                <TitleField
                    activeLanguage={activeLanguage}
                    form={form}
                    maxLength={100}
                />
            </div>
            <FormButtons close={close} />
        </Form>
    );
});
